/**
 * 
 * key
 * 
 */


const key = 'YnVkZ2V0X2NvbG9y'

export default key 